import apiClient from './apiClient';
import { API_ENDPOINTS } from './endpoints';

/**
 * Order of services in the apps.
 * entity: 'category' = "Service" list, 'service' = "Service Subcategory" list.
 * Each call returns the raw `{ IsSuccess, Data, Message }` body so screens can show the message.
 */
const post = async (endpoint, body) => (await apiClient.post(endpoint, body)).data;

const serviceOrderService = {
  list: (entity) => post(API_ENDPOINTS.SERVICE_ORDER.LIST, { entity }),
  history: (entity) => post(API_ENDPOINTS.SERVICE_ORDER.HISTORY, { entity }),
  move: (entity, id, orderNo, admin) => post(API_ENDPOINTS.SERVICE_ORDER.MOVE, { entity, id, orderNo, ...admin }),
  arrange: (entity, ids, admin) => post(API_ENDPOINTS.SERVICE_ORDER.ARRANGE, { entity, ids, ...admin }),
};

export default serviceOrderService;
